/*
|---------------------------------------------------
| Application routing
|
| @see: https://router.vuejs.org/en/essentials/getting-started.html
|---------------------------------------------------
*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from 'providers/auth'
import routes, { LOGIN, HOME, WELCOME } from 'router/routes'
import store from 'store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history', // Careful! https://router.vuejs.org/en/essentials/history-mode.html
  routes
})

router.beforeEach((to, from, next) => {
  if (!auth.loggedIn() && to.name !== LOGIN) {
    let newTo = {
      name: LOGIN
    }

    if (to.name !== HOME) {
      newTo.query = { redirect: to.fullPath }
    }

    next(newTo)
  }
  else if (auth.user.needSetupGuide) {
    next({
      name: WELCOME
    })
  }
  else {
    const permission = to.meta.permission

    // If the user doesn't have the permission then he will be sended back to the last page
    if (permission && !store.getters['hasPermission']({permission})) {
      return next(from)
    }

    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js